﻿export interface IIdentityClaim {
    name: string;
}

export class IdentityClaim {
    name: string;
}